module.exports = __webpack_public_path__ + "img/9788959527922.d1897ba6.jpg";